<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { VERSION_UPDATE_EVENT } from '@/services/versionReloadGuard'

const pending = ref(false)

function apply(detail) {
  pending.value = !!detail?.pending
}

function onUpdate(event) {
  apply(event?.detail)
}

function reloadNow() {
  window.location.reload()
}

onMounted(() => {
  apply(window.__fsjVersionUpdate)
  window.addEventListener(VERSION_UPDATE_EVENT, onUpdate)
})

onUnmounted(() => {
  window.removeEventListener(VERSION_UPDATE_EVENT, onUpdate)
})
</script>

<template>
  <v-sheet
    v-if="pending"
    color="accent"
    class="version-update-banner d-flex align-center ga-2 px-3 py-2"
  >
    <v-icon icon="mdi-update" size="20" />
    <span class="text-body-2 flex-grow-1">
      A new version is ready. This page will not reload while you are typing, so your text stays. Reload when you are done.
    </span>
    <v-btn color="primary" variant="flat" size="small" @click="reloadNow">
      Reload
    </v-btn>
  </v-sheet>
</template>

<style scoped>
.version-update-banner {
  position: sticky;
  top: var(--v-layout-top, 0px);
  z-index: 4;
}
</style>
